<template>
  <div :class="['offer-advantages', 'scrollbar-hidden', `offer-advantages--${theme}`]">
    <base-tooltip
      v-for="advantage in advantages"
      :key="`offer-advantage-${advantage.id}`"
      :token="`offer-advantages-tooltip-${advantage.id}`"
      class="offer-advantages__tooltip">
      <span class="offer-advantages__item">
        <img
          :src="advantage.img"
          :width="isIconCompact ? 16 : 24"
          :height="isIconCompact ? 16 : 24"
          alt="">
        <span class="offer-advantages__item-content">
          {{ getAdvantageText(advantage) }}
        </span>
      </span>
      <template #content>
        <span v-html="getTooltipText(advantage)" />
      </template>
    </base-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTooltip from 'Components/ui/Tooltip/BaseTooltip.vue';
import OfferAdvantagesModel from 'Models/OfferAdvantagesModel';
import { CashbackModel } from 'Models/CashbackModel';

export default {
  name: 'OfferAdvantages',

  components: {
    BaseTooltip,
  },

  props: {
    theme: {
      type: String,
      default: 'default',
      validator: (val) => ['default', 'alt'].includes(val),
    },

    isIconCompact: {
      type: Boolean,
      default: true,
    },

    listModelKey: {
      type: String,
      default: 'LIST_BASE',
      validator: (val) => ['LIST_BASE', 'LIST_GOLD', 'LIST_CURRENCY', 'LIST_ACCOUNTS'].includes(val),
    },
  },

  computed: {
    ...mapGetters(['userCashback']),

    advantages() {
      return OfferAdvantagesModel[this.listModelKey];
    },
  },

  methods: {
    getAdvantageText(advantage) {
      if (advantage.id !== OfferAdvantagesModel.CASHBACK.id || !this.userCashback?.rate) {
        return advantage.text;
      }

      return `${advantage.text} ${(this.userCashback.rate * 100).toFixed(0)}%`;
    },

    getTooltipText(advantage) {
      if (advantage.id !== OfferAdvantagesModel.CASHBACK.id) {
        return advantage.tooltip;
      }

      let cashbackValue;
      if (this.userCashback?.rate) {
        cashbackValue = `a ${(this.userCashback.rate * 100).toFixed(0)}%`;
      } else {
        // eslint-disable-next-line max-len
        cashbackValue = `up to ${(CashbackModel.RATE_TABLE[CashbackModel.RATE_TABLE.length - 1].rate * 100).toFixed(0)}%`;
      }

      return advantage.tooltip.replace(/{cashback}/, cashbackValue);
    },
  },
};
</script>

<style lang="scss" scoped>
  .offer-advantages {
    --column-gap: 8px;
    //--item-column-gap: 4px;
    //--item-padding: 4px;
    //--item-background: linear-gradient(270deg, #{$color--basic-blue} 0%, #{$color--basic-purple} 100%);
    //--item-border-radius: 4px;
    //--item-content-max-width: none;

    display: flex;
    align-items: center;
    overflow-x: auto;
  }

  .offer-advantages__tooltip {
    margin-right: var(--column-gap);

    &:last-child {
      margin-right: 0;
    }
  }

  .offer-advantages__item {
    font-weight: 500;
    font-size: 13px;
    line-height: 1.2;
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    grid-auto-columns: max-content;
  }

  .offer-advantages__item-content {
    max-width: var(--item-content-max-width, none);
  }

  .offer-advantages--default {
    .offer-advantages__item {
      grid-column-gap: var(--item-column-gap, 4px);
      background:
          var(--item-background, linear-gradient(270deg, #{$color--basic-blue} 0%, #{$color--basic-purple} 100%));
      border-radius: var(--item-border-radius, 4px);
      padding: var(--item-padding, 4px);
    }
  }

  .offer-advantages--alt {
    --item-content-max-width: 95px;

    .offer-advantages__tooltip {
      margin: 0
    }

    .offer-advantages__item {
      grid-column-gap: 12px;
      margin: 0;
    }
  }

  @media screen and #{$screen-more-or-1280} {
    .offer-advantages--default {
      flex-wrap: wrap;
      margin-right: calc(-1 * var(--column-gap));
      margin-bottom: calc(-1 * var(--column-gap));
    }

    .offer-advantages__item {
      margin-bottom: var(--column-gap);
    }
  }
</style>
